import { IAnnualReportTemplateDTO } from '../interfaces/annual-report-template-dto.interface';

export type UpdateAnnualReportTemplatePdfTemplateIdDto = Pick<IAnnualReportTemplateDTO, 'id' | 'reportingTemplateId'>;
